export default __webpack_public_path__ + "static/media/airstrapz-cbb-3.003bacf1.png";